import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { UserContextProvider } from "./UserContext";
import { setHistory } from "../utils/navigationUtils";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRouteProvider: React.FC<ProtectedRouteProps> = ({
  children,
}) => {
  const history = useHistory();
  // setHistory(history);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const listendEvent = (e: any) => {
    if (e.type === "LOGGED_IN") {
      setIsLoggedIn(true);
    }
  };

  useEffect(() => {
    document.addEventListener("LOGGED_IN", listendEvent);

    const token = localStorage.getItem("token");

    if (
      ["/create-account", "/login", "/forgot-password", "/privacy-policy", "/terms"].includes(
        window.location.pathname
      )
    ) {
      history.push(window.location.pathname);
    } else if (token) {
      if (window.location.pathname === "/") {
        history.push("/choose-brand");
      }
    } else {
      history.push("/login");
    }

    return () => {
      document.removeEventListener("LOGGED_IN", listendEvent);
    };
  }, [history]);

  const token = localStorage.getItem("token");
  if (!token) {
    return null;
  }

  return <UserContextProvider>{children}</UserContextProvider>;
};

export default ProtectedRouteProvider;
